import { memo } from "react";

import { HotelTemplateType } from "@/lib/gql/__generated__/graphql";

import { generatePreviewUrl } from "./_utils";
import { HotelTemplateListItem } from "./hotel-template-list-item";

import type { HotelTemplateListItemProps } from "./hotel-template-list-item";

const hotelTemplateList: Array<HotelTemplateListItemProps> = [
	{
		templateName: "ベーシック",
		description: "部屋タイプやプランが複数あるスタンダードなホテルにおすすめ",
		keyVisualUrl: "/assets/hotel-template/basic.jpg",
		previewUrl: generatePreviewUrl("1965c02a1bd1f0"),
		hotelTemplateType: HotelTemplateType.Basic,
	},
	{
		templateName: "一棟貸し",
		description: "シンプルな販売でOK！一棟貸しや貸別荘タイプの施設におすすめ",
		keyVisualUrl: "/assets/hotel-template/vacation-rental.jpg",
		previewUrl: generatePreviewUrl("19656ddf09d29d"),
		hotelTemplateType: HotelTemplateType.VacationRental,
	},
	{
		templateName: "ゲストハウス | ドミトリー",
		description: "ドミトリータイプのお部屋がある施設におすすめ",
		keyVisualUrl: "/assets/hotel-template/guesthouse-or-dormitory.jpg",
		previewUrl: generatePreviewUrl("1966a8deea4114"),
		hotelTemplateType: HotelTemplateType.GuesthouseOrDormitory,
	},
	{
		templateName: "宿泊 | デイユース",
		description: "日帰り・デイユース対応の施設におすすめ",
		keyVisualUrl: "/assets/hotel-template/basic-and-day-use.jpg",
		previewUrl: generatePreviewUrl("19637a54142387"),
		hotelTemplateType: HotelTemplateType.BasicAndDayUse,
	},
	{
		templateName: "サウナ付きホテル",
		description: "サウナ付きホテルにぴったり！サウナ併設施設におすすめ",
		keyVisualUrl: "/assets/hotel-template/hotel-with-sauna.jpg",
		previewUrl: generatePreviewUrl("19661469cc01a2"),
		hotelTemplateType: HotelTemplateType.HotelWithSauna,
	},
	{
		templateName: "サウナ施設",
		description: "日帰りサウナなどデイユースだけの施設におすすめ",
		keyVisualUrl: "/assets/hotel-template/sauna-only.jpg",
		previewUrl: generatePreviewUrl("1966a7710cc3a4"),
		hotelTemplateType: HotelTemplateType.SaunaOnly,
	},
	{
		templateName: "キャンプ | グランピング",
		description: "レンタル品やオプション充実のキャンプ・グランピング施設におすすめ",
		keyVisualUrl: "/assets/hotel-template/camping-or-grumping.jpg",
		previewUrl: generatePreviewUrl("19637ccd1752e0"),
		hotelTemplateType: HotelTemplateType.CampingOrGrumping,
	},
];

type Props = {
	hotelID: string;
};

export const HotelTemplateList = memo(({ hotelID }: Props) => {
	return (
		<div className="grid grid-cols-1 gap-10 md:grid-cols-2">
			{hotelTemplateList.map((hotelTemplate) => (
				<HotelTemplateListItem key={hotelTemplate.templateName} hotelID={hotelID} {...hotelTemplate} />
			))}
		</div>
	);
});

HotelTemplateList.displayName = "HotelTemplateList";
